import { useState } from 'react';
import { sandhillsRequest } from '@Components/Utilities/SandhillsUtility';
import LoadingRing from '@Components/MuiWrappers/LoadingRing';
import Modal from '@Components/Shared/Modals/Modal';
import GlobalPaymentsForm from '@Components/Shared/Payments/GlobalPaymentsForm';
import GlobalPaymentsACHForm from '@Components/Shared/Payments/ACH/GlobalPaymentsACHForm';

const GlobalPaymentsModal = (props) => {

    const [loading, setLoading] = useState(true);
    const [render, setRender] = useState(false);
    const [error, setError] = useState('');

    const close = () => props.close?.();

    const ready = () => {
        setLoading(false);
        setRender(true);
    };

    const success = (response, onError = null) => {
        setError('');
        setLoading(true);

        let data = {
            crmid: props.crmid,
            invoiceNumber: props.invoiceNumber,
            amount: props.amount,
            convenience: props.convenience,
            email: props.email,
            description: props.description
        }

        if (response) {
            data.accountType = response.accountType;
            data.accountNumber = response.accountNumber;
            data.routingNumber = response.routingNumber;
            data.token = response.temporary_token;
        }

        sandhillsRequest({
            url: props.SubmitTransactionUrl,
            method: 'post',
            data: data,
            errorHandling: {
                message: 'An error occured during the transaction.',
                showDetails: true,
                useConsole: true,
                useAlert: false
            }
        }).then((data) => {
            if (data && data.Success) {
                props.onSuccess?.(data);
                setLoading(false);
                close();
            } else {
                setError('An error occurred during the transaction.');
                setLoading(false);
                onError?.()
            }
        }).catch((error) => {
            setError('An error occurred during the transaction.');
            setLoading(false);
            onError?.()
        });
    };

    return (
        <>
            <Modal containerClassName='global-payments-modal' onEscapeKeyClose={close} hidden={!render}>
                <Modal.Header onClose={close}>
                    <Modal.Title>
                        <img src={props.LogoUrl} style={{ width: '50%' }} alt="" />
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {props.eCheck ?
                        <GlobalPaymentsACHForm
                            {...props}
                            ready={ready}
                            success={success}
                            error={error}
                        /> :
                        <GlobalPaymentsForm
                            {...props}
                            ready={ready}
                            success={success}
                            loading={loading}
                            setLoading={setLoading}
                            error={loading}
                            setError={setError}
                        />}
                </Modal.Body>
            </Modal>
            {loading && <LoadingRing backdrop />}
        </>
    );
}

export default GlobalPaymentsModal;